import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  declare contentTarget: HTMLElement

  toggle() {
    this.contentTarget.classList.toggle("hidden")
  }
}
